import React, { useContext } from "react";
import Context from "../../context/conventionTrackerContext";
import { IMAGES } from "../../utils/constants";
import "./index.scss";

/**
 * @desc Displays a Product Card.
 */
export const ProductCard = ({
  image,
  license,
  name,
  number,
  price,
  eyebrow,
  footer,
  isSoldOut = false,
  sku,
}) => {
  // CONSTANTS ----------------------------------------------------------------

  const { isLoungeFly, onFavoriteClick, wishlist = {} } = useContext(Context);
  const isEmpty = !wishlist.pskus.includes(sku);

  // COMPONENT ----------------------------------------------------------------

  const renderProductPrice = () => {
    if (isSoldOut && isLoungeFly) {
      return <div className={"sold-out-text label"}>SOLD OUT</div>;
    }
    if (price) {
      return <div className={"product-price label"}>${price}</div>;
    }
  };

  const renderSoldOutFunko = () => {
    if (isSoldOut && !isLoungeFly) {
      return (
        <div className="flag-container">
          <div className={"flag"}>
            <div className={"flag-text"}>SOLD OUT</div>
          </div>
        </div>
      );
    }
  };

  const renderEyeBrow = () => {
    if (!eyebrow) return;
    const props = {
      className: "eyebrow label bold",
    };
    return <div {...props}>{eyebrow}</div>;
  };

  const renderFooter = () => {
    if (!footer) return;
    return <div className={"footer label"}>{footer}</div>;
  };

  const renderFavoriteButton = () => {
    const src = isEmpty ? IMAGES.HEART.EMPTY : IMAGES.HEART.FILLED;
    const props = {
      className: "favorite-button",
    };
    return (
      <button {...props}>
        <img src={src} alt="favorite" />
      </button>
    );
  };

  const productCardProps = {
    className: "col-6 col-lg-3 col-xl-5ths product-card-container",
    onClick: onFavoriteClick,
  };

  return (
    <div
      {...productCardProps}
      data-pid={sku}
      data-name={name}
      data-is-empty={isEmpty}
      data-is-sold-out={isSoldOut}
    >
      <div className="flex product-card px-2">
        <div className={"flex img-container"}>
          <div
            className={`flex number-container ${isSoldOut ? "sold-out" : ""}`}
          >
            {number && <div className={"flex number"}>{number}</div>}
            {renderSoldOutFunko()}
          </div>
          <img
            src={image || IMAGES.PRODUCT.DEFAULT}
            alt={"Product"}
            className={`${isSoldOut ? "hide-img" : ""}`}
            loading="lazy"
          />
        </div>
        <div className="flex title-container">
          {renderEyeBrow()}
          <div className={"license label"}>{license}</div>
          <div className={"name label"}>{name}</div>
          {renderFooter()}
          {renderProductPrice()}
          {renderFavoriteButton()}
        </div>
      </div>
    </div>
  );
};
